import type { SelectProps as ReactSelectProps } from '@react-types/select'
import { ArticleView, ArticleViewRequest } from '../../types'
import { FunctionComponent, SVGProps } from 'react'
import { SelectProps } from 'components/Select/Types'

export interface ArticleViewSelectContainerProps {
  id: string
}

export interface Item<T extends ArticleView | ArticleViewRequest> {
  icon: FunctionComponent<React.PropsWithChildren<SVGProps<SVGSVGElement>>>
  key: T
  name: T
  description?: string
}

export interface ArticleViewSelectProps
  extends Omit<ReactSelectProps<{}>, 'children' | 'variant' | 'onSelectionChange' | 'items'>,
    Pick<SelectProps<ArticleView | ArticleViewRequest>, 'renderSelectValue'> {
  onArticleViewChange: (view: ArticleView) => any
  onArticleViewRequestChange: (viewRequest: ArticleViewRequest) => any
  items: (Item<ArticleView | ArticleViewRequest> | Item<ArticleView | ArticleViewRequest>)[]
}

export const ARTICLE_VIEW_PARAM = 'docView'
